import { Language, LocalStorageItem } from '@constants/index'
import { VelvetSDK } from 'sdk'
import { getActiveProfile } from './helpers'

export const getLanguage = async () => {
  const user = JSON.parse(localStorage.getItem(LocalStorageItem.USER_DATA) as string)
  const activeProfile = getActiveProfile()

  if (user && activeProfile) {
    const preferredLang = await VelvetSDK.Storage.Language.service.getProfilePreferredLanguage(
      user.userID,
      activeProfile.identifier,
    )

    if (preferredLang) {
      return preferredLang
    } else {
      await VelvetSDK.Storage.Language.service.setProfilePreferredLanguage(
        user.userID,
        Language.EN,
        activeProfile.identifier,
      )
    }
  } else {
    return Language.EN
  }
}
